<template>
    <div class="md-layout md-gutter" :class="{'mb-2.5': !placed || placementOnly}">
        <div class="md-layout-item layout-remnant-devices" :class="placed ? (placementOnly ? 'md-size-85' : 'md-size-45') : 'md-size-100'">
            <div class="h-full flex items-center">
                <md-radio v-model="selected" :value="device.id" class="w-full">
                    <div class="w-full flex items-center h-full">
                        <span :class="{'text-xs': placementOnly}">{{ device.number }}</span>
                        <div :style="{ maxWidth: placementOnly ? '10px': '15px' }" class="mx-2">
                            <img :src="device.current_device_type.icon" alt="picto" />
                            <md-tooltip md-direction="top">{{ device.current_device_type.name }}</md-tooltip>
                        </div>
                        <span class="leading-none" :class="{'text-xs': placementOnly}">{{ device.location }}</span>
                        <template v-if="device.plan_id && device.plan_id !== planId">
                            <template v-if="!placementOnly">
                                <span class="ml-2 leading-none italic">|</span>
                                <span class="ml-2 leading-none italic">
                                    Plan : {{ device.plan_id + ' (Position : ' + device.plan_x + 'x' + device.plan_y + ')' }}
                                </span>
                            </template>
                            <template v-if="placementOnly">
                                <span class="ml-1 leading-none italic text-xs">(P)</span>
                            </template>
                        </template>
                    </div>
                </md-radio>
            </div>
        </div>
        <template v-if="placed">
            <template v-if="!placementOnly">
                <div class="md-layout-item md-size-25">
                    <div class="md-multiselect">
                        <label>Placement</label>
                        <multiselect v-model="device.plan_num" @input="updateDevice"
                                     :options="placements" label="label" track-by="label"
                                     :option-height="104"
                                     placeholder=""
                                     :show-labels="false">
                            <template slot="noOptions">La liste est vide</template>
                            <template slot="noResult">Aucun élement correspondant</template>
                        </multiselect>
                    </div>
                </div>
                <div class="md-layout-item md-size-15 px-0">
                    <div class="md-multiselect">
                        <label>Rotation</label>
                        <multiselect v-model="device.plan_orient" @input="updateDevice"
                                     :options="rotations"
                                     :option-height="104"
                                     placeholder=""
                                     :show-labels="false">
                            <template slot="noOptions">La liste est vide</template>
                            <template slot="noResult">Aucun élement correspondant</template>
                        </multiselect>
                    </div>
                </div>
            </template>
            <div class="md-layout-item md-size-15">
                <div class="h-full flex items-center justify-end">
                    <div>
                        <md-button class="md-icon-button md-raised md-danger my-0" :class="{'md-small-icon md-rounded-icon': placementOnly}"
                                   @click="removeDeviceFromPlan">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                        </md-button>
                        <md-tooltip v-if="!placementOnly" md-direction="top">Retirer du plan</md-tooltip>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "PlanDeviceRow",
    props: {
        device: Object,
        placed: Boolean,
        selectedDevice: Object,
        planId: Number,
        placementOnly: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    computed: {
        selected: {
            get: function() {
                return this.selectedDevice?.id ?? null
            },
            set: function(newValue) {
                this.$emit('selectDevice', { deviceId: newValue })
            },
        }
    },
    data() {
        return {
            placements: [
                { value: 1, label: 'Gauche' },
                { value: 2, label: 'Haut' },
                { value: 3, label: 'Droite' },
                { value: 4, label: 'Bas' },
            ],
            rotations: [0, 90, 180, -90],
        }
    },
    methods: {
        async updateDevice() {
            try {
                await this.$store.dispatch('devices/updateDevicePlanInfos', {
                    deviceId: this.device.id,
                    plan_num: this.device.plan_num.value,
                    plan_orient: this.device.plan_orient
                })
            } catch (e) {}
        },
        async removeDeviceFromPlan() {
			// placementOnly is for PWA
            if(this.placementOnly) {
	            this.$emit('removeDevice', this.device)
            }
			// for Admin
			else {
                try {
                    await this.$store.dispatch('devices/removeDeviceFromPlan', {
                        deviceId: this.device.id
                    })
                    await this.$store.dispatch('alerts/success', 'Dispositif supprimé du plan')
                    bus.$emit('device-plan-removed')
                } catch (e) {
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.layout-remnant-devices {
    padding-left: 0;
    .md-radio {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
        margin-right: 0 !important;

        .md-radio-label {
            width: 100%;
            display: flex;
            align-items: center;
        }
    }
    div.flex:last-child {
        margin-bottom: 0 !important;
    }
}
</style>
